<h1>{{ ("perigonMapping" | i18n) || "Perigon Mapping" }}</h1>
<div
  class="organisations"
  *ngIf="customer$ | async as customer">
  <div class="row filter-bar">
    <div class="col-md-12">
      <app-text-search
        class="filter-bar"
        [useQueryParam]="'search'"
        (searchTextChanged)="searchFromInput($event)">
      </app-text-search>
    </div>
  </div>
  <div
    class="organisation-list"
    data-cy="organisations-list">
    <ng-container *ngIf="!(organisationsLoading$ | async); else loading">
      <mat-card
        *ngFor="
          let organisation of organisations$ | async;
          trackBy: trackByOrganisationId
        "
        class="organisation-list-card"
        [attr.data-cy]="'organisation-list-item-id-' + organisation._id">
        <mat-card-title>
          <div data-cy="organisation-name">{{ organisation.name }}</div>
        </mat-card-title>
        <mat-card-content class="organisation-main-body">
          <div
            *ngIf="
              organisation.address &&
              (organisation.address.street ||
                organisation.address.zip ||
                organisation.address.location)
            "
            class="organisation-address"
            data-cy="organisation-address">
            <span *ngIf="organisation.address.street">
              {{ organisation.address.street }}, </span
            ><span *ngIf="organisation.address.zip">
              {{ organisation.address.zip }} </span
            ><span *ngIf="organisation.address.location">
              {{ organisation.address.location }}
            </span>
          </div>
          <div class="organisation-departments-list">
            <app-accordion
              *ngFor="
                let department of organisation.departments;
                trackBy: trackByDepartmentId
              "
              [collapsed]="department.collapsed"
              class="organisation-department">
              <app-accordion-header
                [collapseOnHeaderClick]="true"
                [displayArrowButton]="true"
                [newCollapseButton]="false"
                class="organisation-department-name">
                <span>
                  {{ department.name }}
                </span>
              </app-accordion-header>
              <app-accordion-content
                #accordionContent
                class="organisation-department-options">
                <ng-container
                  *ngIf="!(accordionContent.contentCompletelyHidden$ | async)">
                  <div class="row mb-4">
                    <div class="col-md-6">
                      <mat-form-field>
                        <mat-label>{{
                          ("perigonClientId" | i18n) || "Perigon Client ID"
                            | titlecase
                        }}</mat-label>
                        <input
                          matInput
                          type="number"
                          [ngModel]="
                            getPerigonClientIdForDepartment$(department.id)
                              | async
                          "
                          (ngModelChange)="
                            getPerigonClientIdForDepartment$(
                              department.id
                            ).next($event)
                          "
                          (blur)="
                            updatePerigonClientIdForDepartment(
                              department.id,
                              getPerigonClientIdForDepartment$(
                                department.id
                              ).value?.toString() || ''
                            )
                          "
                          [name]="'perigonClientId-' + department.id"
                          [attr.data-cy]="
                            'perigon-client-id-input-' + department.id
                          "
                          placeholder="{{
                            ('enterClientId' | i18n) || 'Client ID eingeben'
                          }}" />
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="organisation-shifts-list">
                    <app-accordion
                      *ngFor="
                        let shift of getShiftsForDepartment(
                          organisation,
                          department.id
                        );
                        trackBy: trackByShiftId
                      "
                      [collapsed]="true"
                      class="organisation-shift">
                      <app-accordion-header
                        [collapseOnHeaderClick]="true"
                        [displayArrowButton]="true"
                        [newCollapseButton]="false"
                        class="organisation-shift-name">
                        <span>
                          {{ getShiftDisplayName(department, shift) }}
                        </span>
                      </app-accordion-header>
                      <app-accordion-content
                        #shiftAccordionContent
                        class="organisation-shift-options">
                        <ng-container
                          *ngIf="
                            !(
                              shiftAccordionContent.contentCompletelyHidden$
                              | async
                            )
                          ">
                          <div
                            class="row"
                            *ngFor="
                              let perigonTaskMapping of getPerigonTaskMappingsForDepartmentAndShift(
                                department.id,
                                shift.id
                              );
                              trackBy: trackById
                            ">
                            <div class="col">
                              <div class="perigon-mapping-row">
                                <div class="perigon-mapping-details">
                                  <mat-form-field>
                                    <mat-label>{{
                                      ("perigonTaskId" | i18n) ||
                                        "Perigon Task ID" | titlecase
                                    }}</mat-label>
                                    <input
                                      matInput
                                      required
                                      [(ngModel)]="
                                        perigonTaskMapping.perigonTaskId
                                      "
                                      [name]="
                                        'perigonTaskId-' + perigonTaskMapping.id
                                      "
                                      [attr.data-cy]="
                                        'perigonTaskId-' + perigonTaskMapping.id
                                      " />
                                  </mat-form-field>
                                </div>
                                <div class="perigon-mapping-certificates">
                                  <app-certificate-select
                                    [selectedMappedCertificates]="
                                      perigonTaskMapping.certificates || []
                                    "
                                    [noCertificateGroups]="true"
                                    (selectionChanged)="
                                      certificatesSelected(
                                        perigonTaskMapping,
                                        $event
                                      )
                                    "></app-certificate-select>
                                </div>
                                <div class="perigon-mapping-buttons">
                                  <button
                                    class="perigon-mapping-button"
                                    mat-button
                                    type="button"
                                    (click)="
                                      cancelChanges(perigonTaskMapping.id)
                                    "
                                    [matTooltip]="
                                      ('cancel' | i18n) || 'Abbrechen'
                                        | titlecase
                                    ">
                                    <mat-icon
                                      class="perigon-mapping-button-icon"
                                      svgIcon="close"></mat-icon>
                                  </button>
                                  <button
                                    class="perigon-mapping-button save-button"
                                    mat-button
                                    type="button"
                                    (click)="
                                      savePerigonTaskMapping(
                                        perigonTaskMapping.id
                                      )
                                    "
                                    [matTooltip]="
                                      ('save' | i18n) || 'Speichern' | titlecase
                                    ">
                                    <mat-icon
                                      class="perigon-mapping-button-icon"
                                      svgIcon="save"></mat-icon>
                                  </button>
                                  <button
                                    class="perigon-mapping-button delete-button"
                                    mat-button
                                    type="button"
                                    (click)="
                                      deletePerigonTaskMapping(
                                        perigonTaskMapping.id
                                      )
                                    "
                                    [matTooltip]="
                                      ('remove' | i18n) || 'Löschen' | titlecase
                                    ">
                                    <mat-icon
                                      class="perigon-mapping-button-icon"
                                      svgIcon="delete-trash-remove"></mat-icon>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            class="row"
                            *ngFor="
                              let perigonTaskMapping of getPerigonTaskMappingsInCreation$(
                                department.id,
                                shift.id
                              ) | async;
                              let i = index
                            ">
                            <div class="col">
                              <div class="perigon-mapping-row">
                                <div class="perigon-mapping-details">
                                  <mat-form-field>
                                    <mat-label>{{
                                      ("perigonTaskId" | i18n) ||
                                        "Perigon Task ID" | titlecase
                                    }}</mat-label>
                                    <input
                                      matInput
                                      required
                                      [(ngModel)]="perigonTaskMapping.taskId"
                                      [name]="
                                        'newTaskId-' +
                                        department.id +
                                        '-' +
                                        shift.id +
                                        '-' +
                                        i
                                      "
                                      [attr.data-cy]="
                                        'newTaskId-' +
                                        department.id +
                                        '-' +
                                        shift.id +
                                        '-' +
                                        i
                                      " />
                                  </mat-form-field>
                                </div>
                                <div class="perigon-mapping-certificates">
                                  <app-certificate-select
                                    [selectedMappedCertificates]="
                                      perigonTaskMapping.certificates || []
                                    "
                                    [noCertificateGroups]="true"
                                    (selectionChanged)="
                                      certificatesSelected(
                                        perigonTaskMapping,
                                        $event
                                      )
                                    "></app-certificate-select>
                                </div>
                                <div class="perigon-mapping-buttons">
                                  <button
                                    class="perigon-mapping-button"
                                    mat-button
                                    type="button"
                                    (click)="
                                      cancelNewPerigonTaskMapping(
                                        department.id,
                                        shift.id,
                                        i
                                      )
                                    "
                                    [matTooltip]="
                                      ('cancel' | i18n) || 'Abbrechen'
                                        | titlecase
                                    ">
                                    <mat-icon
                                      class="perigon-mapping-button-icon"
                                      svgIcon="close"></mat-icon>
                                  </button>
                                  <button
                                    class="perigon-mapping-button save-button"
                                    mat-button
                                    type="button"
                                    (click)="
                                      saveNewPerigonTaskMapping(
                                        department.id,
                                        shift.id,
                                        i
                                      )
                                    "
                                    [matTooltip]="
                                      ('save' | i18n) || 'Speichern' | titlecase
                                    ">
                                    <mat-icon
                                      class="perigon-mapping-button-icon"
                                      svgIcon="save"></mat-icon>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row mt-4">
                            <div class="col">
                              <button
                                class="outline-pill-button icon-left"
                                type="button"
                                [attr.data-cy]="
                                  'add-perigon-task-mapping-button-' +
                                  department.id +
                                  '-' +
                                  shift.id
                                "
                                (click)="
                                  addNewPerigonTaskMapping(
                                    department.id,
                                    shift.id
                                  )
                                ">
                                <mat-icon
                                  class="custom-text-icon-button-icon"
                                  svgIcon="add-circle-plus"></mat-icon>
                                {{
                                  ("addPerigonTaskMapping" | i18n) ||
                                    "Perigon Task-Mapping hinzufügen"
                                    | titlecase
                                }}
                              </button>
                            </div>
                          </div>
                        </ng-container>
                      </app-accordion-content>
                    </app-accordion>
                    <div
                      class="row mt-4"
                      *ngIf="
                        getShiftsForDepartment(organisation, department.id)
                          .length === 0
                      ">
                      <div class="col">
                        <p class="text-muted">
                          {{
                            ("noShifts" | i18n) || "Keine Schichten vorhanden"
                          }}
                        </p>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </app-accordion-content>
            </app-accordion>
          </div>
        </mat-card-content>
      </mat-card>
    </ng-container>
    <ng-template #loading>
      <div class="loading-container">
        <mat-spinner
          diameter="24"
          data-cy="organisations-loading-spinner"></mat-spinner>
      </div>
    </ng-template>
  </div>
</div>
